module.exports = __webpack_public_path__ + "img/wide.66123634.jpg";